import styled from "styled-components";

import { RebuildRouteDropdownMenu } from "@ryde/controls";
import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const BulkRebuildRoutesCustomContentStyled = styled(
  RebuildRouteDropdownMenu,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "bulk-rebuild-routes-custom-content",
})`
  min-width: 0;
  max-width: none;
  padding: 0;

  gap: 6px;

  .rebuild-route-dropdown-plate {
    margin: 0;
    padding: 6px 10px;
  }

  .rebuild-route-dropdown-plate--providers {
    padding-bottom: 4px;
  }

  .rebuild-route-dropdown-plate--options {
    gap: 2px;
  }

  .rebuild-route-dropdown-plate--checks {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-block: 10px;
  }

  .rebuild-route-dropdown-avoid-tolls-row,
  .rebuild-route-dropdown-skip-cache-row {
    margin-block: 0;
    margin-inline-start: 9px; /* same left edge as the radio circles */
  }

  .rebuild-route-dropdown-option-item.rebuild-route-dropdown-default-action-checkbox {
    margin-inline-start: 0;

    .MuiFormControlLabel-label {
      font-size: 1rem; /* same as the Avoid tolls label */
    }
  }

  .rebuild-route-dropdown-avoid-tolls-row .MuiSvgIcon-root,
  .rebuild-route-dropdown-skip-cache-row .MuiSvgIcon-root {
    font-size: 1.25rem;
  }

  .rebuild-route-dropdown-avoid-tolls-row .MuiCheckbox-root,
  .rebuild-route-dropdown-skip-cache-row .MuiCheckbox-root {
    margin-inline-end: 8px;
  }
`;
